// extracted by mini-css-extract-plugin
module.exports = {"body":"modal_body__3Xzsn","openme":"modal_openme__349Qj","overlay":"modal_overlay__XsAmM"};